import { CwvIssue } from './types';
import styles from './cwv-analyser.module.css';

export const MIN_PANEL_WIDTH = 280;
export const MAX_PANEL_WIDTH = 480;

export const SEVERITY_LABEL: Record<CwvIssue['severity'], string> = {
  error: 'Critical',
  warning: 'Warning'
};

export const METRIC_COLOUR: Record<CwvIssue['metric'], string> = {
  LCP: styles.metricLcp,
  INP: styles.metricInp,
  CLS: styles.metricCls
};
